module.exports = __webpack_public_path__ + "static/media/helexia_charging_icon.2c3d5420.svg";